(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      /* N2 (21.08.): Die Einmalmessung lief VOR den media=print-Stylesheets und froren
         einen falschen Wert ein (gemessen 2638px bei echten 173px) — jede Differenz
         erscheint 1:1 als weisses Band ueber dem transparenten Hero. load misst nach,
         wenn alle Stylesheets aktiv sind; das entprellte resize deckt Fenster- und
         Orientierungswechsel ab (Altbefund, latent schon vor 20.0). */
      window.addEventListener('load', this.setHeaderHeight.bind(this));
      let headerHeightTimer;
      window.addEventListener('resize', () => {
        clearTimeout(headerHeightTimer);
        headerHeightTimer = setTimeout(this.setHeaderHeight.bind(this), 150);
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search'); /* v20.0: alle Instanzen (Modale + Inline + Leiste), nicht nur die erste */

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (Array.prototype.some.call(this.predictiveSearches || [], (ps) => ps.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false); /* v20.0: Null-Guard — Header-Varianten ohne Modal duerfen den Sticky-Header nicht crashen */
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      /* N2 (21.08.): Die Einmalmessung lief VOR den media=print-Stylesheets und froren
         einen falschen Wert ein (gemessen 2638px bei echten 173px) — jede Differenz
         erscheint 1:1 als weisses Band ueber dem transparenten Hero. load misst nach,
         wenn alle Stylesheets aktiv sind; das entprellte resize deckt Fenster- und
         Orientierungswechsel ab (Altbefund, latent schon vor 20.0). */
      window.addEventListener('load', this.setHeaderHeight.bind(this));
      let headerHeightTimer;
      window.addEventListener('resize', () => {
        clearTimeout(headerHeightTimer);
        headerHeightTimer = setTimeout(this.setHeaderHeight.bind(this), 150);
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);
  /* v20.0: Die predictive-search-Section rendert ihre Ergebnisse mit festen IDs
     (predictive-search-results u.a.). Suchen mehrere Instanzen in einem Seitenaufruf
     (zwei Modale bei top-center — Altbefund 19.9/Nr.18 — plus Inline-Feld und Leiste),
     stuenden dieselben IDs mehrfach im DOM. Beim Fokus einer Such-Eingabe fliegen
     deshalb die injizierten Ergebnisbloecke ALLER anderen Instanzen raus — nur der
     Ergebnisblock, nicht der Lade-Spinner, damit die Instanzen benutzbar bleiben. */
  document.addEventListener('focusin', (event) => {
    if (!event.target.classList || !event.target.classList.contains('search__input')) return;
    const own = event.target.closest('predictive-search, search-form');
    document.querySelectorAll('predictive-search, search-form').forEach((ps) => {
      if (ps === own) return;
      ps.querySelectorAll('#predictive-search-results').forEach((results) => results.remove());
      /* v20.0.2: results-Attribut mit entfernen — sonst oeffnet der naechste Fokus
         eine LEERE Box (onFocus prueft nur getAttribute('results')). */
      ps.removeAttribute('results');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
